<template lang="pug">
    .reference
        //- TODO
        //- 1. select CMS (pool of managed webs with the same template)
        //- 2, selelct menu
        //- 3. select page

        .flex-fields
            .input.is-small
                //- :prop="validationPath"
                el-form-item(:label="$t('CMS')")
                    el-select.is-full-width(placeholder="" v-model="cms")
                        el-option(
                            v-for="option in cmsOptions"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id"
                            :disabled="option.isDisabled"
                        )
            .input
                el-form-item(:label="$t('Targetpage')")
                    el-input(
                        v-if="options.menu.loading"
                        type="text"
                        :disabled="true"
                        :placeholder="$t('Select a targetpage ...')"
                    )
                    Treeselect(
                        v-else
                        v-model="reference"
                        :placeholder="$t('select ...')"
                        :multiple="false"
                        :options="treeselectPageOptions"
                        :default-expand-level="Infinity"
                        :close-on-select="true"
                        :open-on-focus="true"
                        :searchable="true"
                        :normalizer="node => ({ label: node.title, ...node })"
                        :clearable="true"
                        :always-open="false"
                    )
                        label(
                            slot="option-label"
                            slot-scope="{ node }"
                            :class="{ optgroup: node.raw.optgroup }"
                        ) {{ node.raw.title }}
                        div(
                            slot="value-label"
                            slot-scope="{ node }"
                            :class="{ optgroup: node.raw.optgroup }"
                        ) {{ node.raw.title }}
</template>

<i18n>
{
    "de": {
        "CMS": "Webauftritt",
        "Targetpage": "Zielseite",
        "select ...": "auswählen ..."
    }
}
</i18n>

<script>
import _ from 'lodash';

import { useSetupStore, usePageStore } from '@/stores';
import NestedSet from '@/nested-set-lib';
import MenuApi from '@/store/api/cms/menu';

import Treeselect from '@riophae/vue-treeselect';

export default {
    name: 'Reference',
    props: {
        // module: {
        //     type: String,
        //     required: true
        // },
        // page: {
        //     type: Object,
        //     required: false
        // },
        // i: {
        //     type: Number
        // }
    },
    data: () => ({
        data: {
            cms: undefined
            // page: undefined,
        },
        options: {
            menu: {
                // menu options related to selected cms
                items: [],
                loading: false
            }
        }
    }),
    components: {
        Treeselect
    },
    watch: {
        cms(fresh, old) {
            if (fresh !== old) this.fetchMenuOptions();
        }
    },
    computed: {
        cms: {
            get() {
                return this.data.cms || _.get(this.page, 'reference.menuItem.menu.cms.id') || this.activeCms.id;
            },
            set(id) {
                if (!this.data.cms || parseInt(this.data.cms) !== parseInt(id)) {
                    this.data.cms = id;
                    this.reference = undefined;
                }
            }
        },
        reference: {
            get() {
                return _.get(this.page, 'reference.menuItem.id');
            },
            set(id) {
                let reference = {
                    download: false,
                    href: '',
                    menuItem: undefined,
                    name: '',
                    target: '_self',
                    type: 'internal'
                };

                this.data.cms = this.cms;

                if (id) reference.menuItem = { id };

                // const payload = {
                //     reference,
                //     i: this.i
                // };

                // store.commit(`${this.module}/form/reference`, payload);

                this.pageStore.setState({ path: 'form.reference', value: reference })
                this.pageStore.setState({ path: 'form.redirect', value: null })
            }
        },
        // currentItem() {
        //     const menuItems = _.get(this.page, 'menuItems') || [];
        //     if (this.i !== null) return menuItems[this.i];
        //     else return null;
        // },
        cmsOptions() {
            let options = this.cmss.filter(el => {
                return el.config.template.id === this.activeCms.config.template.id;
                // && el.id !== this.activeCms.id
            });

            const cms = _.get(this.page, 'reference.menuItem.menu.cms');
            if (cms && cms.id && !options.find(el => parseInt(el.id) === parseInt(cms.id))) {
                const option = {
                    id: cms.id,
                    name: cms.name,
                    isDisabled: true
                };
                options.push(option);
            }

            return options;
        },
        treeselectPageOptions() {
            // const cms = this.cmsOptions.find(el => el.id === this.cms)
            // let menus = _.get(cms, 'config.template.menus', [])
            // menus = _.cloneDeep(menus).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))

            const menuOptions = _.get(this.options, 'menu.items') || [];
            const visibleOptgroups = menuOptions.filter(el => el.menuItems.length).length > 1;

            let tree = [];
            if (menuOptions && menuOptions.length) {
                menuOptions.forEach(menu => {
                    // current menu
                    // get items from current form state
                    // if (menu.id === this.menu.id) {
                    //     let items = _.get(this.menu, 'menuItems', []);

                    //     if (items.length) {
                    //         const optgroup = {
                    //             id: `optgroup-${this.menu.id}`,
                    //             title: this.menu.name,
                    //             isDisabled: true,
                    //             optgroup: true
                    //         };

                    //         items = _.cloneDeep(items);
                    //         items.forEach(item => {
                    //             if (item.deleted === true) item.isDisabled = true;
                    //             // check if same as current item
                    //             if (this.currentItem !== null && this.currentItem.id === item.id)
                    //                 item.isDisabled = true;
                    //         });
                    //         if (visibleOptgroups) tree.push(optgroup);
                    //         tree = [...tree, ...NestedSet.createTree(items)];
                    //     }
                    // } else {
                        const menuOption = _.find(menuOptions, { key: menu.key });
                        let items = _.get(menuOption, 'menuItems', []);

                        if (items.length) {
                            items = _.cloneDeep(items);

                            const optgroup = {
                                id: `optgroup-${menuOption.id}`,
                                title: menuOption.name,
                                isDisabled: true,
                                optgroup: true
                            };

                            if (visibleOptgroups) tree.push(optgroup);
                            tree = [...tree, ...NestedSet.createTree(items)];
                        }
                    // }
                });
            } else {
                const menuItem = _.get(this.page, 'reference.menuItem');
                if (menuItem) {
                    tree = [{ ...menuItem, ...{ isDisabled: true } }];
                }
            }

            return tree;
        },
        setupStore() {
            return useSetupStore();
        },
        cmss() {
            return this.setupStore.cmss;
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        pageStore() {
            return usePageStore();
        },
        page() {
            return this.pageStore.form;
        }
    },
    methods: {
        fetchMenuOptions() {
            this.options.menu.loading = true;
            return MenuApi.fetchList(this.cms)
                .then(menus => {
                    this.options.menu.loading = false;
                    this.options.menu.items = menus;
                })
                .catch(err => {
                    this.options.menu.loading = false;
                    throw err;
                });
        }
    },
    mounted() {
        this.fetchMenuOptions();
    }
};
</script>

<style lang="sass" scoped>
.flex-fields
    display: flex
    width: 100%
    & > .input
        flex-basis: 100%
        flex-grow: 1
        &.is-small
            flex-basis: 33%
            margin-right: 1rem
        .el-form-item
            margin-bottom: 0
</style>
